import EventBgSrc from "@/assets/images/banners/summer-bg.png";
import EventRcSrc from "@/assets/images/banners/summer-rc.svg";
import { colors, spacings } from "@/assets/themes";
import { Banner, Block, Body14, Carousel, H2, List } from "@/components";
import { BANNER } from "@/components/Styles/variants";
import { useAskService, useBanners, useBreakpoints } from "@/modules/hooks";
import polyglot from "@/utils/polyglot";
import CategoryItem from "./Blocks/CategoryItem";

const HomeEventCategories = ({ block }) => {
  const breakpoints = useBreakpoints();

  const calculateSlidesToShow = (length) => {
    if (length <= 2) {
      return { xs: 1.5, lg: 2, xl: 2 };
    }
    if (length === 3) {
      return { xs: 1.5, lg: 3, xl: 3 };
    }
    return { xs: 1.5, lg: 3, xl: 4 };
  };

  return (
    <Block spaceY={spacings.s}>
      {breakpoints.get({ xs: true, md: false }) ? (
        <Block
          marginX={{ xs: `calc(${spacings.m} * -1)`, md: "0px" }}
          spaceY={spacings.m}
        >
          <Carousel
            slideToShow={calculateSlidesToShow(block.data?.length)}
            gutter={breakpoints.get({ xs: spacings.s, md: spacings.m })}
            paddingX={{ xs: spacings.m, md: "0px" }}
            withGutters={breakpoints.get({ xs: true, md: false })}
          >
            {block.data?.map((item, i) => (
              <CategoryItem
                {...item}
                title={item.title || polyglot.t(`categories.${item.id}.name`)}
                key={`categories-horizontal-${block.category_id}-${i}`}
              />
            ))}
          </Carousel>
        </Block>
      ) : (
        <Block
          display="grid"
          gridCols={{ xs: 1, md: 2, xl: 3 }}
          gap={{ xs: spacings.sm, md: spacings.m }}
          marginTop={{ xs: spacings.xs, md: spacings.s }}
        >
          {block.data.map((item) => (
            <CategoryItem
              key={`home-event-category-${item.id}`}
              {...item}
              title={item.title || polyglot.t(`categories.${item.id}.name`)}
            />
          ))}
        </Block>
      )}
    </Block>
  );
};

const HomeEventTab = () => {
  const breakpoints = useBreakpoints();
  const { rawBanners } = useBanners();
  const askService = useAskService();

  const getMockedCategories = () => [
    {
      title: polyglot.t("summer.categories.title1"),
      display: "categories",
      data: [
        {
          id: 7021,
          subtitle: polyglot.t("summer.categories.subtitle1"),
        },
        {
          id: 4015,
          title: polyglot.t("categories.23.name"),
          subtitle: polyglot.t("summer.categories.subtitle2"),
        },
        {
          id: 9003,
          title: polyglot.t("babysitting.baby_sitter"),
          subtitle: polyglot.t("summer.categories.subtitle3"),
        },
      ],
    },
    {
      title: polyglot.t("summer.categories.title2"),
      display: "categories",
      data: [
        {
          id: 2051,
          subtitle: polyglot.t("summer.categories.subtitle4"),
        },
        {
          id: 2013,
          subtitle: polyglot.t("summer.categories.subtitle5"),
        },
        {
          id: 2049,
          subtitle: polyglot.t("summer.categories.subtitle6"),
        },
        {
          id: 2001,
          subtitle: polyglot.t("summer.categories.subtitle7"),
        },
        {
          id: 2008,
          subtitle: polyglot.t("summer.categories.subtitle8"),
        },
      ],
    },
    {
      title: null,
      display: "banner_vertical",
      category_id: null,
      data: ["viewy"],
    },
    {
      title: polyglot.t("summer.categories.title3"),
      display: "categories",
      data: [
        {
          id: 3014,
          title: polyglot.t("categories.22.name"),
          subtitle: polyglot.t("summer.categories.subtitle9"),
        },
        {
          id: 4010,
          subtitle: polyglot.t("summer.categories.subtitle10"),
        },
        {
          id: 1037,
          title: "Réparations",
          subtitle: polyglot.t("summer.categories.subtitle11"),
        },
      ],
    },
    {
      title: polyglot.t("summer.categories.title4"),
      display: "categories",
      data: [
        {
          id: 2048,
          subtitle: polyglot.t("summer.categories.subtitle12"),
        },
      ],
    },
    {
      title: polyglot.t("summer.categories.title5"),
      display: "categories",
      data: [
        {
          id: 5007,
          subtitle: polyglot.t("summer.categories.subtitle13"),
        },
        {
          id: 5006,
          subtitle: polyglot.t("summer.categories.subtitle14"),
        },
        {
          id: 4001,
          subtitle: polyglot.t("summer.categories.subtitle15"),
        },
        {
          id: 4013,
          subtitle: polyglot.t("summer.categories.subtitle16"),
        },
        {
          id: 2032,
          subtitle: polyglot.t("summer.categories.subtitle17"),
        },
        {
          id: 9003,
          subtitle: polyglot.t("summer.categories.subtitle18"),
        },
      ],
    },
    {
      title: polyglot.t("summer.categories.title6"),
      display: "categories",
      data: [
        {
          id: 9003,
          subtitle: polyglot.t("summer.categories.subtitle19"),
        },
        {
          id: 4001,
          subtitle: polyglot.t("summer.categories.subtitle20"),
        },
        {
          id: 29,
          subtitle: polyglot.t("summer.categories.subtitle21"),
          onClick: () => {
            askService.show({ id: 29 });
          },
        },
        {
          id: 1001,
          subtitle: polyglot.t("summer.categories.subtitle22"),
        },
      ],
    },
  ];

  const data = getMockedCategories();

  // const isBannerVisible = () => {
  //   const today = moment();
  //   const endDate = moment("2025-06-20", "YYYY-MM-DD");
  //   return today.isSameOrBefore(endDate);
  // }
  const isBannerVisible = () => true;

  return (
    <Block>
      <List.Header>
        <H2>{polyglot.t("summer.title")}</H2>
      </List.Header>

      <Block
        display="flex"
        flexDirection="column"
        gap={{ xs: spacings.s, md: spacings.l }}
      >
        <Block spaceY={spacings.m} marginTop={spacings.s}>
          {isBannerVisible() && (
            <>
              <Banner
                accent="light"
                title={polyglot.t("summer.banner_points_title")}
                subtitle={polyglot.t("summer.banner_points_subtitle")}
                backgroundImage={EventBgSrc}
                rightBackgroundImage={EventRcSrc}
                size={breakpoints.get({
                  xs: BANNER.SIZE.MEDIUM,
                  xl: BANNER.SIZE.LARGE,
                })}
              />
            </>
          )}
        </Block>
        {data.map((block) => (
          <div key={`home-event-block-${block.title}`}>
            {block.title ? (
              <List.Header>{block.title}</List.Header>
            ) : (
              <Block marginTop={spacings.l} />
            )}
            {block.display === "banner_vertical" &&
              block.data.map((item) => (
                <Banner
                  {...rawBanners[item]}
                  size={breakpoints.get({
                    xs: BANNER.SIZE.MEDIUM,
                    xl: BANNER.SIZE.LARGE,
                  })}
                  key={`home-event-banner-${item}`}
                />
              ))}
            {block.display === "categories" && (
              <HomeEventCategories block={block} />
            )}
          </div>
        ))}
        {isBannerVisible() && (
          <Block marginTop={spacings.s}>
            <Body14
              color={colors.muted}
              strong
              css={`
                font-weight: 400;
              `}
            >
              {polyglot.t("summer.banner_points_subtitle_details")}
            </Body14>
          </Block>
        )}
      </Block>
    </Block>
  );
};

export default HomeEventTab;
